<nb-card>
  <nb-card-body>
    <div id="print-section" class="print-layout">
      <div *ngIf="shop.coverUrl" class="logo-bill">
        <img width="100" [src]="shop.coverUrl" alt="" />
      </div>

      <table width="100%" cellpadding="0" cellspacing="0" class="table-header">
        <tr>
          <td style="text-align: center">
            <h4 class="shop-title">{{ shop.title }}</h4>
          </td>
        </tr>
        <tr>
          <td style="text-align: center">
            <label>
              {{ shop.address }}
            </label>
          </td>
        </tr>
        <tr>
          <td style="text-align: center">
            <label>
              Tel: {{ shop.mobile }}
              <span *ngIf="shop.website"> - Web: {{ shop.website }}</span>
              <span *ngIf="shop.email"> - Email: {{ shop.email }}</span>
            </label>
          </td>
        </tr>

        <tr>
          <td class="height-1"></td>
        </tr>

        <tr>
          <td style="text-align: center">
            <h4>INVOICE</h4>
          </td>
        </tr>
        <tr>
          <td style="text-align: center">
            <label>
              Date:
              {{ receipt.issueDate | date : "dd/MM/yyyy " }}
            </label>
          </td>
        </tr>
        <tr *ngIf="receipt.id.length > 6">
          <td style="text-align: center">
            <label>
              Code:
              {{ receipt.id.substring(receipt.id.length - 6, 6) }}
            </label>
          </td>
        </tr>

        <tr>
          <td style="text-align: center">
            <table
              width="100%"
              style="border: 0px"
              cellpadding="0"
              cellspacing="0"
            >
              <tr>
                <td style="text-align: left; width: 60%">
                  <label>
                    <strong> Buyer: </strong> {{ receipt.customerName }}
                  </label>
                </td>
                <td style="text-align: left; width: 40%">
                  <label>
                    <strong> Tel: </strong> {{ receipt.customerMobile }}
                  </label>
                </td>
              </tr>
              <tr>
                <td colspan="2" style="text-align: left">
                  <strong> Add : </strong> {{ receipt.customerAddress }}
                </td>
              </tr>
            </table>
          </td>
        </tr>

        <tr>
          <td class="height-1"></td>
        </tr>
      </table>

      <table class="table-detail">
        <thead>
          <tr style="text-align: center">
            <th><strong> Pos. </strong></th>
            <th><strong> Code </strong></th>
            <th><strong> Product Name </strong></th>
            <th *ngIf="!isRefLanguage"><strong> Unit </strong></th>
            <th><strong> Quantity </strong></th>
            <th><strong> Price </strong></th>
            <th><strong> Amount </strong></th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let item of receipt.receiptDetails; let i = index">
            <td>{{ i + 1 }}</td>
            <td>{{ item.productCode }}</td>
            <td style="text-align: left">
              <label *ngIf="!isRefLanguage">
                {{ item.productName }}
              </label>
              <label *ngIf="isRefLanguage">
                {{
                  item.productDescription
                    ? item.productDescription
                    : item.productName
                }}
              </label>
            </td>
            <td *ngIf="!isRefLanguage" style="text-align: left">
              <label>
                {{ item.productUnitName }}
              </label>
            </td>
            <td style="text-align: right">
              <label>
                {{ item.quantity | number : 0 }}
              </label>
            </td>
            <td style="text-align: right">
              <label>
                {{ item.price | number : "1.2-2" }}
              </label>
            </td>
            <td style="text-align: right">
              {{ item.netAmount | number : "1.2-2" }}
            </td>
          </tr>
        </tbody>

        <tfoot>
          <tr>
            <td *ngIf="isRefLanguage" colspan="5" style="text-align: right">
              <strong> Sub Total: </strong>
            </td>
            <td *ngIf="!isRefLanguage" colspan="6" style="text-align: right">
              <strong> Sub Total: </strong>
            </td>
            <td style="text-align: right">
              <strong>
                {{ receipt.detailNetAmount | number : "1.2-2" }}
              </strong>
            </td>
          </tr>

          <tr>
            <td *ngIf="isRefLanguage" colspan="5" style="text-align: right">
              <strong>
                Discount
                <span *ngIf="receipt.discountPercent > 0">
                  {{ receipt.discountPercent | number : 0 }}%
                </span>
                :
              </strong>
            </td>
            <td *ngIf="!isRefLanguage" colspan="6" style="text-align: right">
              <strong>
                Discount
                <span *ngIf="receipt.discountPercent > 0">
                  {{ receipt.discountPercent | number : 0 }}%
                </span>
                :
              </strong>
            </td>
            <td style="text-align: right">
              <strong>
                {{ receipt.totalDiscountAmount | number : "1.2-2" }}
              </strong>
            </td>
          </tr>

          <tr *ngIf="receipt.vatAmount > 0">
            <td *ngIf="isRefLanguage" colspan="5" style="text-align: right">
              <strong>
                VAT
                <span> {{ receipt.vatPercent | number : 0 }}% </span>
                :
              </strong>
            </td>
            <td *ngIf="!isRefLanguage" colspan="6" style="text-align: right">
              <strong>
                VAT
                <span> {{ receipt.vatPercent | number : 0 }}% </span>
                :
              </strong>
            </td>

            <td style="text-align: right">
              <strong>
                {{ receipt.vatAmount | number : "1.2-2" }}
              </strong>
            </td>
          </tr>

          <tr>
            <td *ngIf="isRefLanguage" colspan="5" style="text-align: right">
              <strong> Grand Total: </strong>
            </td>
            <td *ngIf="!isRefLanguage" colspan="6" style="text-align: right">
              <strong> Grand Total: </strong>
            </td>
            <td style="text-align: right">
              <strong> {{ receipt.totalAmount | number : "1.2-2" }} </strong>
            </td>
          </tr>
        </tfoot>
      </table>

      <table width="100%" cellpadding="0" cellspacing="0" class="table-header">
        <tr>
          <td colspan="2" class="height-1"></td>
        </tr>

        <tr>
          <td style="text-align: center">
            <strong> Cashier </strong> <br />
            <span> (Sign, full name) </span>
          </td>

          <td style="text-align: center">
            <strong> Customer </strong> <br />
            <span> (Sign, full name) </span>
          </td>
        </tr>
      </table>
    </div>
  </nb-card-body>
</nb-card>
